import { useState } from "react";
import ProjectForm from "./ProjectForm";
import { IprojectForm } from "./Projects";
import { ProjectServices } from "$services";
import useAuth from "$hooks/useAuth";

export const ProjectPopinForm = ({ togglePopin }: IprojectForm) => {
  const { token } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string>("");

  // TODO: remove this code and update useProjectForm to manage new popin
  const handleSubmit = async (data: any) => {
    setSubmitting(true);
    const isEdit = !!data._id;
    const Service = isEdit
      ? ProjectServices.UpdateProject
      : ProjectServices.AddProject;

    const { medias, ...projectData } = data;

    return Service(token, projectData, data._id)
      .then(async (body) => {
        if (body?.error) {
          setError(body.error);
        } else {
          if (!isEdit && medias && medias.length > 0) {
            await ProjectServices.UpdateProject(token, { medias }, body._id);
          }

          togglePopin();
          setError("");
        }
        return body;
      })
      .catch((err) => {
        setError(err.error || err.message || "Erreur Serveur");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <ProjectForm
      onSubmit={handleSubmit}
      projectError={error}
      isSubmitting={submitting}
      onReset={() => togglePopin(false)}
    />
  );
};
